import { Controller } from "@hotwired/stimulus";

// Shows a spinner in place of a link's normal content the moment it's clicked, so a Turbo
// navigation/action that takes a moment (opening a folder, confirming a move) gives immediate
// feedback instead of looking unresponsive. Doesn't need to reset itself: Turbo either replaces
// the element entirely (frame/stream response) or navigates away.
//
// Usage: data-controller="loading-toggle" data-action="click->loading-toggle#start" on the link,
// with data-loading-toggle-target="content" on its normal content and "spinner" on a hidden
// (.d-none) spinner element alongside it.
export default class extends Controller {
  static targets = ["content", "spinner"];

  start() {
    this.element.classList.add("disabled");
    this.element.setAttribute("aria-disabled", "true");
    this.contentTargets.forEach((el) => el.classList.add("d-none"));
    this.spinnerTargets.forEach((el) => el.classList.remove("d-none"));
  }
}
